import '../app/shared/sentry/init'

import { Suspense } from 'react'
import * as ReactDOM from 'react-dom/client'
import { Outlet, RouterProvider, createBrowserRouter } from 'react-router-dom'

import '../../styles/charts.css'
import '../../styles/modal.css'
import '../../styles/tailwind.css'
import '../../styles/timeframe-bar.css'
import { ScrollRestore } from './components/ScrollRestore'
import { RouterErrorElement } from './components/error-view'
import { LoadingScreen } from './components/loading'
import { NotificationWrapper } from './components/notification'
import { SettingsContext } from './context'
import { useTrackPageView } from './hooks/use-track-pageview'
import { insiderTradingModule } from './modules/insider-trading'
import { portfolioModule } from './modules/portfolio'
import { quoteModule } from './modules/quote'
import { lazyLoadComponent } from './util-routing'
import { defineLazyRoutes } from './util-routing'

const router = createBrowserRouter([
  {
    path: '/',
    Component: () => {
      useTrackPageView()

      return (
        <Suspense fallback={<LoadingScreen />}>
          <SettingsContext.Provider value={FinvizSettings}>
            <NotificationWrapper>
              <Outlet />
              <ScrollRestore />
            </NotificationWrapper>
          </SettingsContext.Provider>
        </Suspense>
      )
    },
    ErrorBoundary: RouterErrorElement,
    children: defineLazyRoutes([
      ...insiderTradingModule,
      ...portfolioModule,
      ...quoteModule,
      {
        path: '/charts',
        Component: lazyLoadComponent({
          chunkName: 'charts',
          load: () => import(/* webpackChunkName: "charts" */ './modules/charts'),
        }),
      },
      {
        path: '/save_to_portfolio.ashx',
        Component: lazyLoadComponent({
          chunkName: 'save-to-portfolio',
          load: () => import(/* webpackChunkName: "save-to-portfolio" */ './modules/save-to-portfolio/Route'),
        }),
      },
      {
        path: '/create_alert.ashx',
        Component: lazyLoadComponent({
          chunkName: 'create-alert',
          load: () => import(/* webpackChunkName: "create-alert" */ './modules/create-alert/Route'),
        }),
      },
    ]),
  },
])

const rootEl = document.getElementById('root')
const root = ReactDOM.createRoot(rootEl!)

root.render(<RouterProvider router={router} />)
